import React from 'react'
import { Icon } from 'semantic-ui-react'

import { EmptyDate, formatters } from '@cbgms/base/utils/datetime'

import { KnockOperator } from '../Knock/KnockTypes'
import { IColumn } from '../Types'
import { DateTimePickerBasic } from '../../form/DateTimePickerBasic'

export interface IDateFilterProps {
  operators?: KnockOperator[]
  onChange: (value: Pick<IColumn, 'filter' | 'filterOperator'>) => void

  filter: string
  filterOperator: string
}

export const DateFilter: React.FC<IDateFilterProps> = props => {
  const { onChange, filter } = props

  return (
    <DateTimePickerBasic
      input={
        {
          iconPosition: 'left',
          value: formatters.date.format(filter),
          onChange: (e: any) => {
            const value = e.target ? e.target.value : e
            const apiValue = formatters.date.parse(value)
            const searchValue = apiValue !== EmptyDate ? apiValue : ''

            onChange({ filter: searchValue })
          }
        } as any
      }
      meta={{ touched: false } as any}
      label=''
      timeFormat={false}
      formatters={formatters.date}
      icon={<Icon name={filter ? 'close' : 'search'} onClick={() => onChange({ filter: '' })} style={{ pointerEvents: 'auto' }} />}
      fluid
    />
  )
}

export default React.memo(DateFilter)
